module.exports = __webpack_public_path__ + "static/img/role-pt.511f5ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-5/role-pt.png
// module id = oqb2
// module chunks = 1